import './modules/menu.ts';
import './modules/slider-homepage.ts';
import './modules/filters.ts';
import './modules/video.ts';


/*
	BEWARE
	when you update the scripts, you need to copy the bundle generated in convert it in babel compiler (https://babeljs.io/repl).
	Than move the transpiled version to application/assets/legacy.js
	the lagacy file is loaded in layout-footer.twig
	This fix is required as far as we support IE11
*/
